module.exports = __webpack_public_path__ + "static/media/video.0b08b90e.mp4";